<div class="flex min-h-[100dvh] items-stretch">
  <aside
    class="w-60 transform transition-transform duration-300 ease-in-out fixed inset-y-0 left-0 z-40 md:static md:translate-x-0 bg-white/80 backdrop-blur-md backdrop-brightness-75"
    [class.translate-x-0]="showSidebar()"
    [class.-translate-x-full]="!showSidebar()"
    (click)="$event.stopPropagation()"
  >
    <div class="card flex flex-col bg-secondary-lightest px-3 min-h-full">
      <div class="pt-4 flex justify-between items-center gap-2">
        <img src="/images/logo.svg" alt="logo" class="w-[70%]" />
        <button
          class="cursor-pointer md:hidden"
          (click)="toggleSidebar()"
        >
          <i class="ph ph-x text-2xl text-secondary-dark"></i>
        </button>
      </div>

      <div class="mt-8 overflow-y-auto flex-1 min-h-0">
        <ul class="list-none">
          <li>
            <a
              routerLink="/customer/dashboard"
              routerLinkActive="text-secondary-dark font-bold bg-white"
              class="flex items-center cursor-pointer p-3 rounded-border hover:bg-white duration-150 transition-colors"
            >
              <i class="ph-duotone ph-house text-2xl mr-2"></i>
              Meu portal
            </a>
          </li>
          <li>
            <a
              routerLink="/customer/orders"
              routerLinkActive="text-secondary-dark font-bold bg-white"
              class="flex items-center cursor-pointer p-3 rounded-border hover:bg-white duration-150 transition-colors"
            >
              <i class="ph-duotone ph-package text-2xl mr-2"></i>
              Pedidos
            </a>
          </li>
          <li>
            <a
              routerLink="/customer/cards"
              routerLinkActive="text-secondary-dark font-bold bg-white"
              class="flex items-center cursor-pointer p-3 rounded-border hover:bg-white duration-150 transition-colors"
            >
              <i class="ph-duotone ph-credit-card text-2xl mr-2"></i>
              Cartões
            </a>
          </li>
          <li>
            <a
              routerLink="/home"
              routerLinkActive="text-secondary-dark font-bold bg-white"
              class="flex items-center cursor-pointer p-3 rounded-border hover:bg-white duration-150 transition-colors"
            >
              <i class="ph-duotone ph-shopping-bag text-2xl mr-2"></i>
              Comprar
            </a>
          </li>
        </ul>
      </div>

      <div class="mt-auto">
        <a
          routerLink="/customer/profile"
          routerLinkActive="text-secondary-dark font-bold bg-white"
          class="flex items-center cursor-pointer p-4 gap-2 rounded-border hover:bg-white duration-150 transition-colors"
        >
          <img
            [src]="customer()?.profilePictureUrl ?? '/images/user-avatar.webp'"
            alt="user-image"
            class="w-10 h-10 rounded-full bg-red object-cover"
          />
          <span class="font-bold">Meu perfil</span>
        </a>
        <hr class="border-gray-300" />
        <a
          (click)="logOut()"
          class="flex items-center cursor-pointer p-4 gap-2 rounded-border hover:bg-white duration-150 transition-colors text-red-600"
        >
          <i class="ph ph-sign-out text-2x"></i>
          Sair
        </a>
      </div>
    </div>
  </aside>

  <main
    class="flex-1 px-5 lg:px-20 lg:pt-10"
    (click)="$event.stopPropagation()"
  >
    <div class="text-right">
      <button
        pButton
        (click)="toggleSidebar()"
        class="mt-3 btn-primary md:hidden mb-2"
      >
        <i class="ph ph-list"></i>
      </button>
    </div>
    <router-outlet />
  </main>
</div>
<div
  class="overlay-backdrop"
  [class.active]="showSidebar() && isMobile()"
></div>

@if(loading()){
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
>
  <p-progress-spinner ariaLabel="loading" />
</div>
}
